import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import EyeIcon from '@mui/icons-material/RemoveRedEye';
import { TableTooltip } from '../table';
import { DateTooltipProps } from './props';

dayjs.extend(relativeTime);
dayjs.locale('es');

export const DateTooltip = ({
    date,
    icon,
    format = 'DD-MM-YYYY HH:mm:ss',
    tooltip,
    showFornow,
    substractHours = 5,
}: DateTooltipProps) => {
    let customDate: any = dayjs(date);

    if (substractHours)
        customDate = customDate.subtract(substractHours, 'hours');

    if (showFornow) customDate = customDate.fromNow();
    else customDate = customDate.format(format);

    return (
        <TableTooltip value={tooltip || customDate}>
            {icon || (
                <EyeIcon sx={{ marginRight: '10px', color: 'primary.main' }} />
            )}
            {customDate}
        </TableTooltip>
    );
};
